export default __webpack_public_path__ + "static/media/logo-yammer.1240499b.svg";